export const enrollmentForm = {
  title: "Demande de Pré-Inscription",
  subtitle: "Remplissez ce formulaire et nous vous contacterons pour commencer le processus d'admission",
  
  contactInfo: "Informations de Contact",
  parentName: "Nom complet du parent/tuteur",
  email: "Email",
  phone: "Téléphone",
  
  childrenInfo: "Informations sur les Enfants",
  child: "Enfant",
  addChild: "Ajouter un autre enfant",
  childName: "Nom de l'enfant",
  birthDate: "Date de naissance",
  currentSchool: "École actuelle",
  currentSchoolPlaceholder: "Optionnel",
  desiredLevel: "Niveau souhaité",
  
  levels: {
    infantil: "Infantile (3-5 ans)",
    primaryC1: "Primaire C1 (6-8 ans)",
    primaryC2: "Primaire C2 (9-11 ans)"
  },
  
  preferences: "Préférences",
  preferredStartDate: "Date de début souhaitée",
  immediate: "Immédiat",
  howDidYouHear: "Comment nous avez-vous connu?",
  
  sources: {
    web: "Site web",
    recommendation: "Recommandation",
    socialMedia: "Réseaux sociaux",
    openHouse: "Journée portes ouvertes",
    other: "Autre"
  },
  
  servicesInterest: "Services d'Intérêt",
  services: {
    transport: "Transport scolaire",
    earlyBirds: "Matinée (8:00-8:45h)",
    lunch: "Déjeuner"
  },
  
  comments: "Commentaires ou questions",
  commentsPlaceholder: "Dites-nous toute information supplémentaire que vous jugez pertinente...",
  
  privacyPolicy: "J'ai lu les informations sur la protection des données",
  
  submit: "Soumettre la Demande",
  submitting: "Envoi en cours...",
  
  success: "Demande envoyée avec succès! Nous vous contacterons bientôt.",
  error: "Erreur lors de l'envoi de la demande. Veuillez réessayer ou nous contacter directement.",

  stepper: {
    steps: {
      contact: "Vos données",
      children: "Vos enfants",
      preferences: "Préférences",
      services: "Services",
      review: "Révision",
    },
    next: "Continuer",
    previous: "Précédent",
    stepOf: "Étape {current} de {total}",
  },
};